
import { CONSTANTS } from "client/utils/constants";
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import { IBulkOrderRequest, ISearchCriteria, ISearchCriteriaRequest, ManagedEquipementRequest, VehicleRequest } from "Model/IApiObjectBulkOrderData";
import { setIsApprovalOverride, setManagedEquipementTypes, setOrderCartData, setOrderData, setSelectedCostCenter, setVehicleType } from "Store/Component/BulkOrder/BulkOrderAction";
import { getSaveBulkOrder } from "Store/OrderManagement/BulkOrderSave/BulkOrderSaveAction";
import { formatPrice } from "utils";

export const ReactToAPI = (props: any) => {

  const dispatch = props?.dispatch
  const orderId = props.orderId;
  const selectedCostCenter = props.selectedCostCenter;
  const userDetails = props.userDetails;
  const orderAction = props.item;
  const cartDetails = props?.cartDetails
  const isApprovalOverride = props?.isApprovalOverride

  const apiObject: IBulkOrderRequest = {
    orderId: 0,
    branchId: 0,
    userEmailId: "",
    savedBy: "",
    orderAction: "",
    isBulkOrder: true,
    isMandAFlag: false,
    isApprovalOverride: false,
    attachments: [],
    searchCriteria: []
  }

  apiObject.orderId = orderId;
  apiObject.branchId = parseInt(selectedCostCenter?.value);
  apiObject.userEmailId = userDetails?.emailId;
  apiObject.savedBy = userDetails?.emailId;
  apiObject.orderAction = orderAction;
  apiObject.isBulkOrder = true;
  apiObject.attachments = [];
  apiObject.isMandAFlag = false;
  apiObject.isApprovalOverride = isApprovalOverride;

  let cartDetailsTemp = cartDetails?.length > 0 ? [...cartDetails] : [];

  for (let i = 0; i < cartDetailsTemp?.length; i++) {
    let searchCriteria: ISearchCriteria = {
      searchCriteriaId: parseInt(cartDetailsTemp[i]?.orderSearchCriteriaId) || 0,
      orderRequestSubTypeId: parseInt(cartDetailsTemp[i]?.orderRequestSubTypeId) || 0,
      vehicleTypeId: parseInt(cartDetailsTemp[i]?.vehicleTypeId) || 0,
      manufacturerId: parseInt(cartDetailsTemp[i]?.manufacturerId) || 0,
      stateAvailabilityId: parseInt(cartDetailsTemp[i]?.stateAvailabilityId) || 0,
      programStatusId: parseInt(cartDetailsTemp[i]?.programStatusId) || 0,
      annualHoursId: parseInt(cartDetailsTemp[i]?.annualHoursId) || 0,
      deckSizeId: parseInt(cartDetailsTemp[i]?.deckSizeId) || 0,
      deckTypeId: parseInt(cartDetailsTemp[i]?.deckTypeId) || 0,
      autonomousId: parseInt(cartDetailsTemp[i]?.autonomousId) || 0,
      sizeId: parseInt(cartDetailsTemp[i]?.sizeId) || 0,
      typeId: parseInt(cartDetailsTemp[i]?.typeId) || 0,
      parentVehicleId: parseInt(cartDetailsTemp[i]?.parentVehicleId) || 0,
      styleId: parseInt(cartDetailsTemp[i]?.styleId) || 0,
      lengthId: parseInt(cartDetailsTemp[i]?.lengthId) || 0,
      fuelTankId: parseInt(cartDetailsTemp[i]?.fuelTankId) || 0,
      chargingStationId: parseInt(cartDetailsTemp[i]?.chargingStationId) || 0,
      treeCareEquipmentTypeId: parseInt(cartDetailsTemp[i]?.treeCareEquipmentTypeId) || 0,
      horsePowerId: parseInt(cartDetailsTemp[i]?.horsePowerId) || 0,
      fuelTypeId: parseInt(cartDetailsTemp[i]?.fuelTypeId) || 0,
      seatingCapacityId: parseInt(cartDetailsTemp[i]?.seatingCapacityId) || 0,
      enclosedCabId: parseInt(cartDetailsTemp[i]?.enclosedCabId) || 0,
      capacityId: parseInt(cartDetailsTemp[i]?.capacityId) || 0,
      vehicleCapacityId: 0,
      noOfDoorsId: 0,
      upfitOptionId: 0,
      driveTrainId: 0,
      orderTypeId: parseInt(cartDetailsTemp[i]?.orderTypeId),
      categoryId: parseInt(cartDetailsTemp[i]?.categoryId) || 0,
      requests: []
    }

   for (let j = 0; j < cartDetailsTemp[i]?.requests?.length; j++) {
    let requests : ISearchCriteriaRequest = {
      requestId: parseInt(cartDetailsTemp[i]?.requests[j]?.requestId) ?? 0,
    orderTypeId: parseInt(cartDetailsTemp[i]?.requests[j]?.orderTypeId) ?? 0,
    quantity: cartDetailsTemp[i]?.requests[j]?.quantity,
    price: cartDetailsTemp[i]?.requests[j]?.price,
    comments: cartDetailsTemp[i]?.requests[j]?.comments,
    make: cartDetailsTemp[i]?.requests[j]?.make,
    description: cartDetailsTemp[i]?.requests[j]?.description,
    driverTitle: "",
    driveTrain: "",
    hasQuoteAttached: false,
    isUsed: false,
    model: cartDetailsTemp[i]?.requests[j]?.model ?? "",
    newAssetNo: "",
    noOfDoors: 0,
    poDesc1:cartDetailsTemp[i]?.requests[j]?.podesc1 ?? "",
    poDesc2: cartDetailsTemp[i]?.requests[j]?.podesc2 ?? "",
    pricePerUnit: 0,
    upfitOption: "",
    vehicleCapacity: "",
    vehicleType: "",
    vinSerial: "",
    year: 0,
    itemNumber: cartDetailsTemp[i]?.requests[j]?.itemNumber ? parseInt(cartDetailsTemp[i]?.requests[j]?.itemNumber) : 0,
    assetModelId: cartDetailsTemp[i]?.requests[j]?.assetModelId ? parseInt(cartDetailsTemp[i]?.requests[j]?.assetModelId) : 0,
    orderRequestSubTypeId: parseInt(cartDetailsTemp[i]?.orderRequestSubTypeId) || 0,
      managedEquipmentDealer: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.hasOwnProperty("managedEquipmentDealerQuotePriceId") ? {
        managedEquipmentDealerQuotePriceId: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.managedEquipmentDealerQuotePriceId ? parseInt(cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.managedEquipmentDealerQuotePriceId) : 0,
        reasonId: 0,
        dealerName: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerName,
        quotePrice: parseFloat(getOnlyNumbers(cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.quotePrice)),
        estimatedPrice: parseFloat(getOnlyNumbers(cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.estimatedPrice)),
        dealerPhone: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerPhone,
        dealerContact: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerContact,
        dealerEmail: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerEmail,
        dealerAdd1: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerAdd1,
        dealerAdd2: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerAdd2,
        dealerAdd3: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerAdd3,
        dealerCity: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerCity,
        dealerState: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerState,
        dealerZip: cartDetailsTemp[i]?.requests[j]?.managedEquipmentDealer?.dealerZip,
      } : {},
    attachments: cartDetailsTemp[i]?.requests[j]?.attachments?.length ? cartDetailsTemp[i]?.requests[j]?.attachments : [],
    vendorDetail: {},
    reasons: [],
    vehicleDriverDetails: []
    }
    searchCriteria.requests.push(requests)
   }
   apiObject.searchCriteria.push(searchCriteria)
  }
  dispatch(getSaveBulkOrder(apiObject))
}

export const APIToReact = (props: any) => {
  const {
    dispatch,
    BulkOrdeByIdValue
  } = props;

  const currentBranch = {
    "label": BulkOrdeByIdValue?.costCenter,
    "key": BulkOrdeByIdValue?.branchId,
    "text": BulkOrdeByIdValue?.costCenter,
    "value": BulkOrdeByIdValue?.branchId
  }

  const getCatalogItems = (catalogItemList:any, selectedItemList:any) => {
    return catalogItemList?.map((item:any)=>{
      item.quantity = 1;
      const findItem = selectedItemList?.find((i:any)=>i.assetModelId === item.assetModelId)
      if(findItem){
        item.isSelected = true;
        item.quantity = findItem?.quantity;
      }
      return item;
    })
  }

  const getSearchDropdown = (orderType:any) => {
    const list = BulkOrdeByIdValue?.subTypeDropDownList?.overAllSubTypeDropDown?.find((val:any)=>val.equipmentType == orderType)
    return list?.data
  }

  let orderDetails: any = [];
  let CartDataTemp: any = [];
  BulkOrdeByIdValue?.searchCriteria?.map((vehicle: any, searchCriteriaIndex: any) => {
    if (vehicle?.orderType === CONSTANTS.VEHICLE_REQUEST) {
      let vehicleRequestTemp: any = [];
      vehicle?.requests?.map((element: any, index: any) => {
        vehicleRequestTemp.push({
          requestId: element?.requestId,
          orderTypeId: element?.orderTypeId,
          itemNumber: element?.itemNumber,
          quantity: element?.quantity,
          price: element?.price,
          comments: element?.comments,
          make: element?.make,
          description: element?.description,
          attachments: element?.attachments,
          equipmentIndex: searchCriteriaIndex + 1,
          assetModelId: element?.assetModelId,
          collapse: true
        })

        const vehicaleData: VehicleRequest = {
          selectedVehicleType: { label: vehicle?.subOrderType, value: vehicle.orderRequestSubTypeId, key:vehicle.orderRequestSubTypeId, text: vehicle?.subOrderType},
          selectedMake: {label: element?.make, text: element?.make, value: element?.make},
          quantityVehicle: element.quantity,
          selectedSpec: {
            assetModelId: element?.assetModelId,
            orderRequestSubTypeId: vehicle?.orderRequestSubTypeId,
            orderRequestSubType: vehicle?.subOrderType,
            make: element?.make?.label,
            price: element?.price,
            description: element?.description,
            label: element?.description,
            value: element?.description
          },
          orderSearchCriteriaId: vehicle?.orderSearchCriteriaId,
          requestId: element?.requestId,
          itemNumber: element?.itemNumber,
          requestIndex: searchCriteriaIndex + 1,
          equipmentIndex: searchCriteriaIndex + 1,
          comment: element?.comments || '',
          attachments: vehicle?.requests[0]?.attachments ?? [],
          orderRequestSubTypeId: vehicle?.orderRequestSubTypeId,
          orderRequestSubTypeLabel: vehicle?.subOrderType,
          requestType: CONSTANTS?.VEHICLE_REQUEST,
          orderTypeId:  vehicle?.orderTypeId,
          selectedVehicleTypeError: '',
          selectedMakeError: '',
          quantityVehicleError: '',
          selectedSpecError: ''
        }
        orderDetails.push(vehicaleData);
      })
      const tempVehicleValues = {
        orderRequestSubTypeId: parseInt(vehicle?.orderRequestSubTypeId),
        orderRequestSubTypeLabel: vehicle?.subOrderType,
        vehicleTypeId: vehicle?.orderRequestSubTypeId,
        orderTypeId: vehicle?.orderTypeId,
        orderType: CONSTANTS?.VEHICLE_REQUEST,
        requestIndex: searchCriteriaIndex + 1,
        requests: vehicleRequestTemp,
        orderSearchCriteriaId: vehicle?.orderSearchCriteriaId
      }
      
      CartDataTemp?.push(tempVehicleValues)
    } else {
      let requestTemp: any = [];
      vehicle?.requests?.map((element: any, index: any) => {
        requestTemp.push({
          requestId: element?.requestId,
          orderTypeId: element?.orderTypeId,
          itemNumber: element?.itemNumber,
          quantity: element?.quantity,
          price: element?.price,
          calculatedPrice: formatPrice(element?.managedEquipmentDealerQuotePriceVM?.estimatedPrice, 2),
          comments: "",
          make: element?.make,
          description: element?.description,
          attachments: element?.attachments,
          requestIndex: searchCriteriaIndex+1,
          equipmentIndex: element?.assetModelId,
          managedEquipmentDealer: element?.managedEquipmentDealerQuotePriceVM ? {
            managedEquipmentDealerQuotePriceId:  element?.managedEquipmentDealerQuotePriceVM?.managedEquipmentDealerQuotePriceId ,
            reasonId: element?.managedEquipmentDealerQuotePriceVM?.reasonId ,
            dealerName: element?.managedEquipmentDealerQuotePriceVM?.dealerName,
            quotePrice: formatPrice(element?.managedEquipmentDealerQuotePriceVM?.quotePrice, 2),
            estimatedPrice: formatPrice(element?.managedEquipmentDealerQuotePriceVM?.estimatedPrice, 2),
            dealerPhone: element?.managedEquipmentDealerQuotePriceVM?.dealerPhone,
            dealerContact: element?.managedEquipmentDealerQuotePriceVM?.dealerContact,
            dealerEmail: element?.managedEquipmentDealerQuotePriceVM?.dealerEmail,
            dealerAdd1: element?.managedEquipmentDealerQuotePriceVM?.dealerAdd1,
            dealerAdd2: element?.managedEquipmentDealerQuotePriceVM?.dealerAdd2,
            dealerAdd3: element?.managedEquipmentDealerQuotePriceVM?.dealerAdd3,
            dealerCity: element?.managedEquipmentDealerQuotePriceVM?.dealerCity,
            dealerState: element?.managedEquipmentDealerQuotePriceVM?.dealerState,
            dealerZip: element?.managedEquipmentDealerQuotePriceVM?.dealerZip,
          }: {},
          assetModelId: element?.assetModelId,
          collapse: true,
          isSelected: true
        })
      })

      const getEquipmentType = (subOrderType: any, subOrderId: any) => {
        return { 
          label: subOrderType,
          text:  subOrderType,                
          value: subOrderId, 
          key: subOrderId 
        }
      }
      const managedEquipementData: ManagedEquipementRequest = {
        requestType: CONSTANTS?.MANAGED_EQUIPMENT,
        selectedEquipementType: getEquipmentType(vehicle.subOrderType, vehicle.orderRequestSubTypeId),
        selectedEquipementTypeError: '',
        searchCriteria: {
          manufacturerId: vehicle?.manufacturerId || null,
          stateAvailabilityId: vehicle?.stateAvailabilityId || null,
          programStatusId: vehicle?.programStatusId || null,
          annualHoursId: vehicle?.annualHoursId || null,
          deckSizeId: vehicle?.deckSizeId || null,
          deckTypeId: vehicle?.deckTypeId || null,
          categoryId: vehicle?.categoryId || null,
          autonomousId: vehicle?.autonomousId || null,
          sizeId: vehicle?.sizeId || null,
          typeId: vehicle?.typeId || null,
          parentVehicleId: vehicle?.parentVehicleId || null,
          styleId: vehicle?.styleId || null,
          lengthId: vehicle?.lengthId || null,
          fuelTankId: vehicle?.fuelTankId || null,
          chargingStationId: vehicle?.chargingStationId || null,
          treeCareEquipmentTypeId: vehicle?.treeCareEquipmentTypeId || null,
          horsePowerId: vehicle?.horsePowerId || null,
          fuelTypeId: vehicle?.fuelTypeId || null,
          seatingCapacityId: vehicle?.seatingCapacityId || null,
          enclosedCabId: vehicle?.enclosedCabId || null,
          capacityId: vehicle?.capacityId || null,
        },
        selectedCatalogItems: requestTemp,
        requestIndex: searchCriteriaIndex + 1,
        orderSearchCriteriaId: vehicle?.orderSearchCriteriaId,
        orderTypeId: vehicle?.orderTypeId,
        equipmentIndex: 0,
        attachments: vehicle?.requests[0]?.attachments ?? [],
        catalogItem: getCatalogItems(vehicle.searchResult, requestTemp),
        searchDropdowns: getSearchDropdown(vehicle.subOrderType)
      }
      const managedEquipTemp = {
        orderTypeId: vehicle?.orderTypeId,
        orderType:  CONSTANTS?.MANAGED_EQUIPMENT,
        orderRequestSubTypeId: vehicle?.orderRequestSubTypeId,
        orderRequestSubTypeLabel: vehicle?.subOrderType,
        vehicleTypeId: vehicle?.orderRequestSubTypeId,
        requestIndex: searchCriteriaIndex + 1,
        requests: requestTemp,
        orderSearchCriteriaId: vehicle?.orderSearchCriteriaId,
        ...managedEquipementData?.searchCriteria
      }
      orderDetails.push(managedEquipementData);
      CartDataTemp.push(managedEquipTemp);
    }
  })

  if(BulkOrdeByIdValue?.subTypeDropDownList?.managedEquipmentSubTypeDropDown?.length){
    dispatch(setManagedEquipementTypes(BulkOrdeByIdValue?.subTypeDropDownList?.managedEquipmentSubTypeDropDown));
  }

  if(BulkOrdeByIdValue?.subTypeDropDownList?.vehicleSubTypeDropDown?.length){
    dispatch(setVehicleType(BulkOrdeByIdValue?.subTypeDropDownList?.vehicleSubTypeDropDown));
  }
  
  dispatch(setOrderData(orderDetails));
  dispatch(setOrderCartData(CartDataTemp))
  dispatch(setSelectedCostCenter(currentBranch))
  dispatch(setIsApprovalOverride(BulkOrdeByIdValue?.isApprovalOverride))
}